
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Template } from '@/models/template';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {getTemplateListHeaders} from '@/views/admin/template/template';
   import {templateService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue' ),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class TemplateListPage extends Base {
    public headers: VHeaders[] = getTemplateListHeaders(this);
    public pagedTemplates: Template[] = [];
    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('templates.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteTemplate();
        },
    };
    public typeToDelete: Template = {
        name: '', text: '',
    };
    public searched: boolean = false;
    public deleted: boolean = false;

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addTemplate') {
            this.$router.push({ name: 'admin.templates.add' });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('templates.btnAddTemplate'), disabled: false, visible: true, class: 'btn', label: this.$t('templates.btnAddTemplate'), click: 'addTemplate', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'templates');
        
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.actions = [{
            type: 'link',
            icon: 'fas fa-edit',
            title: this.$t('templates.templateGridHeaders.gridAction.edit') as string,
            action: (model: Template, storeId: string) => ({ name: 'admin.templates.edit', params: { id: model.id } }),
        }, {
            type: 'button',
            icon: 'fas fa-trash-alt',
            title: this.$t('templates.templateGridHeaders.gridAction.delete') as string,
            color: 'error',
            action: (model: Template, storeId: string) => { this.confirmDelete(model); },
        }];
        this.getTemplates();
    }
    public async getTemplates(): Promise<void> {
        try {
            this.loading = true;
            const response = await templateService.getTemplates(this.pagination, '');
            this.pagedTemplates = response.results;
            this.pagination.totalItems = response.total;
        } finally {
            this.loading = false;
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }
    public confirmDelete(item: Template): void {
        this.deleteDialog.model = true;
        this.typeToDelete = item;
    }
    public async deleteTemplate(): Promise<void> {
        this.deleteDialog.loading = true;
        await templateService.deleteTemplate(this.typeToDelete.id);
        this.deleteDialog.loading = false;
        this.deleteDialog.model = false;
        this.deleted = true;
        this.showAlert(true, this.$t('templates.alertDeleteTemplate'));
        this.getTemplates();
    }
}
